/// <reference path="../Libs/angular.min.js" />
/// <reference path="../Libs/angular-route.js" />

var AccountType = {
    User: 0,
    Company: 1,
    Partner: 2,
    PartnerSuperAdmin: 3,
    Admin: 4,
    SuperAdmin: 5
};

var ssoEndPoints =
{
    /// <summary>
    /// No Api's Available
    /// </summary>
    None: 0,

    /// <summary>
    /// Authenticate Api Available
    /// </summary>
    Authenticate: 1 << 0, // returns 1 = 2 to power of 0

    /// <summary>
    /// Unlink Api Available
    /// </summary>
    Unlink: 1 << 1, // returns 2 = 2 to power of 1

    /// <summary>
    /// The change password Api Available
    /// </summary>
    ChangePassword: 1 << 2, // returns 4 = 2 to power of 2

    /// <summary>
    /// Attach Client User Api Available
    /// </summary>
    AttachClientUser: 1 << 3, // returns 8 = 3  to power 3

    /// <summary>
    /// Get client accounts by email Api Available
    /// </summary>
    GetClientAccountsByEmail: 1 << 4, // returns 16 = 4 to power 4

    /// <summary>
    /// Get clients attached to user Api Available
    /// </summary>
    AttachClientUsers: 1 << 5,

    /// <summary>
    /// Get additional accounts Api Available
    /// </summary>
    GetAdditionalAccounts: 1 << 6,

    /// <summary>
    /// The create account Api Available
    /// </summary>
    CreateAccount: 1 << 7
};

var gatorClients = {
    Mail: 1,
    Express: 2,
    Leads: 3,
    OldSocial: 4,
    Workflow: 5,
    Docs: 6,
    SignOn: 7,
    Creator: 8,
    Survey: 9,
    SendForensics: 10,
    SEO: 11,
    Popup: 12,
    Report: 13,
    Social: 14
};

(function () {

    'use strict';

    var app = angular.module('app',
    [
        'ngRoute',
        'ngInputModified',
        'ui.bootstrap',
        'vcRecaptcha',
        'mwl.confirm',
        'underscore',
        'angularLoad',
        'ngBootbox',
        'ngCookies'
    ]);

    app.config(['$routeProvider', '$httpProvider', '$locationProvider', '$provide', routes]);

    app.config([
        'inputModifiedConfigProvider', function(inputModifiedConfigProvider) {
            inputModifiedConfigProvider
                .disableGlobally();
        }
    ]);
    app.config(['$sceDelegateProvider',function ($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain.  Notice the difference between * and **.
            "http://www.sendforensics.com/partners/communigator/**",
            "https://www.sendforensics.com/partners/communigator/**"
        ]);
    }]);

    

    function routes($routeProvider, $httpProvider, $locationProvider, $provide) {


        $routeProvider.when('/',
            {
                templateUrl: 'assets/templates/blank.html'
            })
            .when('/GatorHome',
                {
                    templateUrl: 'assets/templates/home.html',
                    data: {
                        title: 'Home'
                    }
                })
            .when('/FeatureRequest',
                {
                    templateUrl: 'assets/templates/FeatureRequest.html',
                    controller: 'featureRequestController',
                    controllerAs: 'vm',
                    data: {
                        title: 'Feature Request'
                    }
                })
            .when('/SocialWizard',
                {
                    controller: 'newSocialWizardController',
                    controllerAs: 'vm',
                    templateUrl: 'assets/templates/newSocialWizard.html',
                    data: {
                        title: 'Account Wizard'
                    }
                })
            .when('/create',
                {
                    controller: 'forceSSOController',
                    controllerAs: 'vm',
                    templateUrl: 'assets/templates/forceSSO.html',
                    data: {
                        title: 'Create Account'
                    }
                })
            .when('/accounts',
            {
                controller: 'accountsController',
                templateUrl: 'assets/templates/accounts.html',
                data: {
                    title: 'Accounts'
                }
            })
            .when('/login',
            {
                controller: 'loginController',
                templateUrl: 'assets/templates/login.html',
                data: {
                    title: 'Login'
                }
            })
            .when('/account/password/request',
            {
                controller: 'requestPasswordController',
                templateUrl: 'assets/templates/request_password.html',
                data: {
                    title: 'Request Password'
                }

            })
            .when('/account/ipauthentication',
            {
                controller: 'ipAuthenticationController',
                templateUrl: 'assets/templates/ip_authentication.html',
                data: {
                    title: 'IP Authentication'
                }
            })
            .when('/account',
            {
                controller: 'createAccountController',
                templateUrl: 'assets/templates/create_account.html',
                controllerAs: 'vm',
                data: {
                    title: 'Create Account'
                }
            })
            .when('/account/activate',
            {
                controller: 'activateAccountController',
                templateUrl: 'assets/templates/activate_account.html',
                data: {
                    title: 'Activate Account'
                }
            })
            .when('/account/:accountId',
            {
                controller: 'editAccountController',
                templateUrl: 'assets/templates/edit_account.html',
                data: {
                    title: 'Edit Account'
                }
            })
            .when('/account/password/reset',
            {
                controller: 'resetPasswordController',
                templateUrl: 'assets/templates/reset_password.html',
                data: {
                    title: 'Reset Password'
                }

            })
            .when('/account/password/reset/:accountId',
            {
                controller: 'resetPasswordController',
                templateUrl: 'assets/templates/reset_password.html',
                data: {
                    title: 'Reset Password'
                }
            })
            .when('/account/authenticator/reset',
            {
                controller: 'resetAuthenticatorController',
                templateUrl: 'assets/templates/reset_authenticator.html',
                data: {
                    title: 'Reset Authenticator'
                }
            })
            .when('/account/password/change',
            {
                controller: 'changePasswordController',
                templateUrl: 'assets/templates/change_password.html',
                data: {
                    title: 'Change Password'
                }
            })
            .when('/account/password/expired',
            {
                controller: 'changePasswordController',
                templateUrl: 'assets/templates/expired_password.html',
                data: {
                    title: 'Expired Password'
                }
            })
            .when('/company/list',
            {
                controller: 'companiesController',
                controllerAs: 'vm',
                templateUrl: 'assets/templates/company/companies.html',
                data: {
                    title: 'Company List'
                }
            })
            .when('/company/:companyId',
            {
                controller: 'editCompanyController',
                controllerAs: 'vm',
                templateUrl: 'assets/templates/company/edit_company.html',
                data: {
                    title: 'Edit Company'
                }
            })
            .when('/error',
            {
                controller: 'errorController',
                templateUrl: 'assets/templates/error.html',
                data: {
                    title: 'Error'
                }
            })
            .when('/dashboard',
            {
                controller: 'dashboardController',
                templateUrl: 'assets/templates/dashboard.html',
                data: {
                    title: 'Dashboard'
                }
            })
            .when('/wizard',
            {
                controller: 'wizardController',
                controllerAs: 'vm',
                templateUrl: 'assets/templates/wizard2.html',
                data: {
                    title: 'Account Wizard'
                }
            })
            .when('/home',
                {
                    controller: 'marketingFrameController',
                    templateUrl: 'assets/templates/signup/marketingframe.html',
                    data: {
                        title: 'GatorExpress Info'
                    }
                })
            .when('/SignUp/GatorExpress',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorExpress Info'
                }
            })
            .when('/SignUp/GatorMail',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorMail Info'
                }
            })
            .when('/SignUp/GatorWorkflow',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorWorkflow Info'
                }
            })
            .when('/SignUp/GatorLeads',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorLeads Info'
                }
            })
            .when('/SignUp/GatorSocial',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorSocial Info'
                }
            })
            .when('/SignUp/GatorDocs',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorDocs Info'
                }
            })
            .when('/SignUp/GatorSurvey',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorSurvey Info'
                }
            })
            .when('/SignUp/GatorSendforensics',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorSendforensics Info'
                }
            })
            .when('/SignUp/GatorPopup',
            {
                controller: 'marketingFrameController',
                templateUrl: 'assets/templates/signup/marketingframe.html',
                data: {
                    title: 'GatorPopup Info'
                }
            })
            .when('/SSOLogout',
            {
                templateUrl: 'assets/templates/ssologout.html',
                data: {
                    title: 'SSO Logout'
                }
            })
            .when('/Logout',
            {
                //controller: 'loginController',
                //templateUrl: 'assets/templates/logout.html',
                //data: {
                //    title: 'Logout'
                //}
                templateUrl: 'assets/templates/ssologout.html',
                data: {
                    title: 'SSO Logout'
                }
            })
            .when('/Authenticator',
            {
                controller: 'authenticatorController',
                templateUrl: 'assets/templates/authenticator.html',
                data: {
                    title: 'Authenticator'
                }
            })
            .when('/thirdparty/forensics',
            {
                controller: 'forensicsController',
                controllerAs: 'vm',
                templateUrl: 'assets/templates/thirdparty/forensics.html',
                data: {
                    title: 'GatorForensics'
                }
            })
            .when('/impersonate/resetting',
            {
                templateUrl: 'assets/templates/reset_sso.html',
                data: {
                    title: 'SSO Resetting User'
                }
            })
            .when('/impersonate/:accountId',
            {
                controller: 'impersonateController',
                controllerAs: 'vm',
                templateUrl: 'assets/templates/impersonate.html',
                data: {
                    title: 'Impersonate'
                }
            })
              .when('/register',
                {
                    controller: 'registerController',
                    controllerAs: 'vm',
                    templateUrl: 'assets/templates/register/create.html',
                    data: {
                        title: 'Register'
                    }
                })
            .when('/registrations',
                {
                    controller: 'registrationsController',
                    controllerAs: 'vm',
                    templateUrl: 'assets/templates/register/list.html',
                    data: {
                        title: 'Registrations'
                    }
                })
            .when('/registration/:id',
                {
                    controller: 'registrationController',
                    controllerAs: 'vm',
                    templateUrl: 'assets/templates/register/view.html',
                    data: {
                        title: 'Registration'
                    }
            })
            .when('/permissions',
                {
                    controller: 'oAuthPermissionsController',
                    templateUrl: 'assets/templates/oAuthPermissions.html',
                    data: {
                        title: 'Permissions'
                    }
                })
            .otherwise('/');
        $locationProvider.html5Mode(true);

        $httpProvider.interceptors.push(['$q', '$location', '$rootScope',
            function ($q, $location, $rootScope) {
                return {
                    'responseError': function (rejection) {

                        if (rejection.status === 401) {
                            $location.url('/login');
                        } else {
                            var response = rejection.data;

                            if (response !== null && response !== void(0) && response.errors && response.unhandled) {
                                $rootScope.currentError = response;

                                $location.url('/error');
                            }
                        }

                        return $q.reject(rejection);
                    }
                };
            }
        ]
            );

        $provide.decorator('$sniffer',
        [
            '$delegate', function ($sniffer) {
                var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
                var hasEvent = $sniffer.hasEvent;
                $sniffer.hasEvent = function (event) {
                    if (event === 'input' && msie === 10) {
                        return false;
                    }
                    hasEvent.call(this, event);
                };
                return $sniffer;
            }
        ]);

        if (window.history && window.history.pushState) {
            $locationProvider.html5Mode(true);
        }
    }

})();